/** Connection-to-Create (spec �6D) ? dragging a connection from a node's
 * output handle and releasing over empty canvas space shows a small
 * popup of compatible next node types (`NodeDefinition.suggestedNext`
 * from the SOURCE node's registry entry). Picking one creates that node
 * at the drop position AND the edge in one step. */

import { useEffect, useRef, useSyncExternalStore } from 'react'
import { useTranslation } from 'react-i18next'
import { getAuthMatrixRevision, subscribeAuthMatrix } from './authMatrixRuntime'
import { isVisibleInAddNodeCatalog } from './canvasNodeCatalog'
import { getNodeCatalogRevision, subscribeNodeCatalog } from './nodeCatalogRuntime'
import { getNodeDefinition, useNodeIconRevision } from './nodeRegistry'
import { useCanvasNodeRegistryI18n } from './nodeRegistryI18n'

interface Props {
  x: number
  y: number
  sourceNodeType: string
  onPick: (nodeType: string) => void
  onClose: () => void
}

export default function ConnectionSuggestPopup({ x, y, sourceNodeType, onPick, onClose }: Props) {
  const { t } = useTranslation('canvas')
  const { nodeLabel } = useCanvasNodeRegistryI18n()
  const ref = useRef<HTMLDivElement>(null)
  useNodeIconRevision()
  useSyncExternalStore(subscribeNodeCatalog, getNodeCatalogRevision, getNodeCatalogRevision)
  useSyncExternalStore(subscribeAuthMatrix, getAuthMatrixRevision, getAuthMatrixRevision)
  const sourceDef = getNodeDefinition(sourceNodeType)
  const options = sourceDef.suggestedNext
    .filter((nodeType) => isVisibleInAddNodeCatalog(nodeType))
    .map((nodeType) => getNodeDefinition(nodeType))

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose()
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [onClose])

  if (options.length === 0) {
    return null
  }

  return (
    <div className="pcv-connection-suggest" style={{ left: x, top: y }} ref={ref}>
      <div className="pcv-connection-suggest-title">{t('connectionSuggest.title')}</div>
      {options.map((def) => (
        <button key={def.nodeType} type="button" className="pcv-context-menu-item" onClick={() => onPick(def.nodeType)}>
          <span className="pcv-context-menu-icon" style={{ color: def.color }}>
            {def.icon}
          </span>
          {nodeLabel(def.nodeType, def.label)}
        </button>
      ))}
    </div>
  )
}
